export const DOCUMENT_LIST = [
  { key: "panDocId", label: "PAN Card", code: "PAN" },
  { key: "tanDocId", label: "TAN", code: "TAN" },
  { key: "gstDocId", label: "GST Certificate", code: "GST" },
  { key: "membershipFormDocId", label: "Membership Form", code: "MEMBERSHIP" },
  { key: "tradingLicenseDocId", label: "Trading License", code: "TRADING_LICENSE" },
  { key: "undertakingDocId", label: "Undertaking", code: "UNDERTAKING" },
  { key: "proofOfPaymentDocId", label: "Proof of Payment", code: "PROOF_OF_PAYMENT" },
];

export const DOCUMENT_GROUPS_LIST = [
  { key: "nocDocs", label: "NOC Documents", code: "NOC" },
  { key: "otherFiles", label: "Other Files", code: "OTHER" },
];
